let step = 0

export function draw(ctx, ctx2, imgs, path, callback, isfinish) {
  requestAnimationFrame(() => {
    draw_line(ctx, imgs, path)
    draw_img(ctx2, imgs, path, callback)

    let finish = 0
    imgs.forEach((bike) => {
      if (bike.finished) {
        finish += 1
      }
    })

    if (finish == imgs.length - 1) {
      let item = imgs.find((row) => {
        return !row.finished
      })

      step = item.step
    }

    if (finish == imgs.length) {
      let show_dialog = true

      if (step == 0) {
        show_dialog = false
      }

      isfinish(step, show_dialog)
    } else {
      draw(ctx, ctx2, imgs, path, callback, isfinish)
    }
  })
}

function draw_line(ctx, imgs, path) {
  const c = document.getElementById('myCanvas')

  imgs = [...imgs]

  const height = c.clientHeight
  const width = (c.clientHeight / 1080) * 1282
  ctx.clearRect(0, 0, width, height)

  const bike = imgs.reduce((a, b) => {
    return a.finish > b.finish ? a : b
  })

  ctx.beginPath()

  for (let index = 0; index <= bike.i; index++) {
    if (!index) {
      ctx.moveTo(path[index].x, path[index].y)
    } else {
      ctx.lineTo(path[index].x, path[index].y)
    }
  }

  ctx.lineTo(bike.x, bike.y)
  ctx.strokeStyle = '#a41e2e'
  ctx.lineWidth = 18
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.stroke()
}

function draw_img(ctx, imgs, path, callback) {
  const c = document.getElementById('myCanvas')

  const height = c.clientHeight
  const width = (c.clientHeight / 1080) * 1282
  ctx.clearRect(0, 0, width, height)

  imgs.forEach((bike) => {
    ctx.drawImage(bike.img, bike.x - 41, bike.y - 48, 83, 62)
    ctx.font = '14px Arial'
    ctx.fillText(bike.no, bike.x - 1, bike.y - 29)

    if (bike.finished) {
      return
    }

    const speed = 4

    if (path[bike.i + 1].x == path[bike.i].x) {
      if (path[bike.i + 1].y > path[bike.i].y) {
        bike.y += speed

        if (bike.y > path[bike.i + 1].y) {
          bike.y = path[bike.i + 1].y
        }
      } else {
        bike.y -= speed
        if (bike.y < path[bike.i + 1].y) {
          bike.y = path[bike.i + 1].y
        }
      }
    } else if (path[bike.i + 1].y == path[bike.i].y) {
      if (path[bike.i + 1].x > path[bike.i].x) {
        bike.x += speed
        if (bike.x > path[bike.i + 1].x) {
          bike.x = path[bike.i + 1].x
        }
      } else {
        bike.x -= speed
        if (bike.x < path[bike.i + 1].x) {
          bike.x = path[bike.i + 1].x
        }
      }
    }

    if (bike.x == path[bike.i + 1].x && bike.y == path[bike.i + 1].y) {
      bike.i += 1
      const arr = [0, 2, 3, 5, 6, 8, 9, 10, 12, 13, 14, 17, 18, 22, 23, 25, 28, 30, 31, 35]
      const step = arr.findIndex((row) => {
        return row == bike.i
      })

      if (step != -1) {
        callback(step)
        bike.step = step
      }
    }

    if (bike.step == bike.finish || bike.i == path.length - 1) {
      bike.finished = true
    } else {
      bike.finished = false
    }
  })
}
